import React, { Component } from 'react';
import Page from '../pages/Page';
import { injectIntl } from 'react-intl';


class Print extends Component {
    getMetaData() {
        return {
            title: this.pageTitle(),
            meta: this.pageMeta(),
            link: this.pageLink()
        };
    }

    pageTitle = () => {
        return 'Print Order';
    };

    pageMeta = () => {
        return [
            { name: 'description', content: 'Print Order' }
        ];
    };

    pageLink = () => {
        return [];
    };

    componentDidMount(){
        setTimeout(()=>{
            var printJS = require('print-js');
            window && printJS({
                printable: '/invoice/download' + window.location.search, 
                type:'pdf',
                showModal:true});
        },1000)
    }

    render() {
        if (typeof window === "undefined") {
            return <div></div>
        }
        return (
            <Page {...this.getMetaData()}>
                <style>
                    {`
                        .app-container{
                            margin-top:0!important;
                            margin: 5px!important;
                        }
                        .layout-nav{
                            display:none;
                        }
                    `}
                </style>
            </Page>
        );
    }
}

export default injectIntl(Print);




// WEBPACK FOOTER //
// app/pages/Print.jsx